import * as React from 'react';
import moment from 'moment';

import GridMonths from '../../components/grid/months';
import { GridMonthContainerProps } from '../../components/grid/container';


const GridMonthContainerView: React.StatelessComponent<GridMonthContainerProps> = props => {
    const daysOfTheWeek = moment.weekdays(true);
    return (
        <div className="ace-cal-grid-container block-inner">
            <ul className="ace-cal-grid-weekdays" aria-hidden="true">
                {
                    daysOfTheWeek.map(day => <li className="ace-cal-grid-weekday" key={day}>{day}</li>)
                }
                </ul>

            <GridMonths />
        </div>
    );
}

export default GridMonthContainerView;